<template>
  <v-container v-if="hasPrivilege()">
    <v-layout>
      <v-flex sm4 class="mt-2">
        <h2>Agent Management</h2>
      </v-flex>
      <v-flex sm4 offset-sm4 class="text-xs-right">
        <AddAgentDialog
          @result="showMessage"
          :eligible="agents.length <= maximumNumberOfAgentGroup()"
          :maximumNumberOfAgentMembers="maximumNumberOfAgentMembers()"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm4 offset-sm8>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <v-data-table
      :headers="headers"
      :items="agents"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td class="text-xs-right">
          <span title="Available">{{ props.item.agent_groups_count }}</span>
          |
          <span title="Max Agents">
            {{ props.item.numbers_of_agent }}
          </span>
        </td>
        <td class="text-xs-center" style="min-width: 120px">
          <div class="actions">
            <ViewAgentDialog
              :agentDetails="props.item"
              :maximumNumberOfAgentMembers="maximumNumberOfAgentMembers()"
            />
            <EditAgentDialog
              :agentDetails="props.item"
              :maximumNumberOfAgentMembers="maximumNumberOfAgentMembers()"
              @result="showMessage"
            />
          </div>
        </td>
      </template>
      <template v-slot:pageText="props">
        Agents {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ message }}
    </v-snackbar>
  </v-container>
  <v-container v-else>
    <v-layout>
      <v-flex sm4 class="mt-2">
        <h2>Agent Management</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <h3>You are not allowed to create team.  </h3>
        <p>Please upgrade your subscription to premium or corporate package</p>
                <br />
                <router-link to="/subscription-package"
                  ><p>click here to go to subscription page</p></router-link
                >
      </v-flex>
    </v-layout>
    
  </v-container>
</template>
<script>
  import api from "../api/datadash";
  import { mapState } from "vuex";
  import ViewAgentDialog from "../components/agent/ViewAgentDialog.vue";
  import AddAgentDialog from "../components/agent/AddAgentDialog.vue";
  import EditAgentDialog from "../components/agent/EditAgentDialog.vue";
  import utilities from "../api/utilities";
  export default {
    components: { ViewAgentDialog, AddAgentDialog, EditAgentDialog },
    data() {
      return {
        loading: false,
        search: "",
        headers: [
          {
            text: "#",
            value: "id",
            align: "right",
          },
          { text: "Name", value: "name", align: "center" },
          { text: "Code", value: "code", align: "center" },
          { text: "Agents", value: "numbers_of_agent", align: "right" },
          { text: "Action", sortable: false, align: "center" },
        ],
        agents: [],
        color: "",
        message: "",
        snackbar: false,
      };
    },
    computed: {
      ...mapState(["auth", "application"]),
    },
    created() {
      this.fetchAgents();
    },
    methods: {
      async fetchAgents() {
        this.loading = true;
        try {
          const { data } = await api.fetchData(this.auth.token, "agent-group");
          this.agents = data.data.groups;
        } catch (e) {
          // console.log(e);
        }
        this.loading = false;
      },
      showMessage(event) {
        this.color = event[1];
        this.message = event[0];
        this.snackbar = true;
        if (this.color == "success") {
          this.fetchAgents();
        }
      },
      maximumNumberOfAgentGroup() {
        return utilities.maximumNumberOfAgentGroup(
          this.application.subscriptionData.subscriptionFeatures
        );
      },
      maximumNumberOfAgentMembers() {
        return utilities.maximumNumberOfAgentMembers(
          this.application.subscriptionData.subscriptionFeatures
        );
      },
      hasPrivilege() {
      if (!this.application.subscriptionData) {
        return false;
      } else if (
        this.application.subscriptionData.subscriptionPlan.package_id < 3
      ) {
        return false;
      } else {
        return true;
      }
    },
    },
  };
</script>
<style scoped>
  .actions {
    display: none;
  }
  tr:hover td > .actions {
    display: block;
  }
</style>
